import { ChangeDetectionStrategy, Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-shared-modal',
    templateUrl: './modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ModalComponent {
    @Input() public header = 'Modal Title';
    @Input() public subheader = '';
    @Input() public footerButtonText = '';
    @Input() public showLogout = false;
    @Input() public footerButtonDisabled = false;
    @Input() public cancelButtonText = 'Cancel';
    @Input() public klass = '';
    @Input() public message = '';
    @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
    @Output() saved: EventEmitter<void> = new EventEmitter<void>();
    @Output() loggedOut: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        @Optional() private readonly dialogRef: MatDialogRef<ModalComponent> | null,
    ) { }

    onCancel(): void {
        this.cancel.emit();
        this.dialogRef?.close();
    }

    close(): void {
        this.dialogRef?.close();
    }

    buttonClicked(): void {
        this.saved.emit();
    }

    logout(): void {
        this.loggedOut.emit();
    }
}
